import React from 'react';
import '../../shared/LibraryTheme.scss';
import globe from '../../assets/globe.svg';
import gallonsGasIcon from '../../assets/gallonofgas.svg';
import matureTree from '../../assets/maturetrees.svg';
import TimerComponent from '../TimerComponent/TimerComponent';
import {handleNegativeScenario} from '../../shared/shared-utility';
interface IDSIBOThirdComponentProps {
  screenOption: string;
  timer: number;
  galloneGas: number | undefined | null;
  matureTrees: number | undefined | null;
  siteImage: string;
}

function DSIBOThirdComponent(props: IDSIBOThirdComponentProps) {
  let { galloneGas, matureTrees } = props;
  let screenOption = props.screenOption.toLowerCase();
  let iboHeadingClassName, iboContainerClassName, gasMaturePage;
  if (screenOption === 'landscape') {
    gasMaturePage = 'ibo-third-page';
    iboHeadingClassName = 'ibo-heading';
    iboContainerClassName = 'ibo-container';
  } else {
    gasMaturePage = 'ibo-third-page ds-portrait-container';
    iboHeadingClassName = 'ibo-heading ibo-heading-portrait';
    iboContainerClassName = 'ibo-container ibo-portrait';
  }
  return (
    <div className={gasMaturePage}>
      <TimerComponent />
      <div className={iboHeadingClassName}>
        {/* <div className="heading">Till date</div> */}
        <div className="sub-heading">
        Using advanced technologies, this building saved
        </div>
      </div>
      <div className={iboContainerClassName}>
        <div className="text-container">
          <div className="ibo-gallons-gas">
            <div>
              <img className="gallone-gas-img" src={gallonsGasIcon} />
            </div>
            <div className="gallone-gas-container">
              <div className="text">{handleNegativeScenario(galloneGas)}</div>
              <div className="sub-text">
                equivalent tons of gas from being consumed*
              </div>
            </div>
          </div>
          <div className="ibo-mature-trees">
            <div>
              <img className="mature-tree-img" src={matureTree} />
            </div>
            <div className="mature-trees-container">
              <div className="text">{handleNegativeScenario(matureTrees)}</div>
              <div className="sub-text">
              tree seedlings that would have required a decade to mature*
              </div>
            </div>
          </div>
        </div>
        <div className="image-container">
          <div className="ibo-global-image">
            <img className="ibo-image" src={globe} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DSIBOThirdComponent;
